import { render } from "./ProjectOverviewPage.vue?vue&type=template&id=7a7e505b&ts=true"
import script from "./ProjectOverviewPage.vue?vue&type=script&lang=ts"
export * from "./ProjectOverviewPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__